import {} from 'viem';
import {} from '../createConfig.js';
import {} from '../types/properties.js';
import {} from '../types/utils.js';
export function getClient(config, parameters = {}) {
    let client = undefined;
    try {
        client = config.getClient(parameters);
    }
    catch { }
    return client;
}
//# sourceMappingURL=getClient.js.map